import { alpha } from '@instructure/ui-color-utils';
var generateComponentTheme = function generateComponentTheme(_ref) {
  var colors = _ref.colors,
    borders = _ref.borders,
    transitions = _ref.transitions,
    typography = _ref.typography;
  return {
    borderWidth: borders.widthSmall,
    borderStyle: borders.style,
    borderColor: colors.tiara,
    disabledBorderColor: colors.tiara,
    borderRadius: borders.radiusMedium,
    fontFamily: typography.fontFamily,
    outlineColor: colors.tiara,
    focusBorderColor: colors.brand,
    focusOutlineColor: alpha(colors.brand, 50),
    errorBorderColor: colors.crimson,
    errorOutlineColor: alpha(colors.crimson, 50),
    wrapperTransition: "all ".concat(transitions.duration, " ease-out"),
    paddingOfInput: '8px',
    colorOfRceInputPlaceholder: colors.ash,
    black: '#222f3e'
  };
};
export default generateComponentTheme;